






























































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { formRules } from '@/common/util/validator';
import { Toast,ImagePreview } from 'vant';
import { counter,imageDialog } from "@/components"
import { TbGoods,TbGoodsSpecs } from '@/http';
import { fmoney } from '@/common/money';
import calculate from '@/common/util/calculate';
@Component({
    components: {
        counter,imageDialog
    },
}) 
export default class productDetail extends Vue {
    public $refs!: {
        imageDialog:HTMLFormElement;
    };
    fmoney=fmoney;

 
    show=false;

    form:any={};
    /**库存 */
    stock=1;
    originStock=0;
    nowStock=0;

    id="";

    @Prop({
        default:true
    })
    isZeroStock:Boolean;
    @Prop({
        default:""
    })
    gwList:string;
    oldGwList=[];

    @Prop({
        type:Object,
        default:()=>{
            return{
                id:"",
                name:"",
                gradeDiscount:null,
            }
        }
    })
    memberInfo;

    /**规格 */
    specsSelectedList =[];

    selectedList=[];
    selectedSpecName="";

    /**禁止取消选中 */
    noCancel = false;

    /**折扣,优惠: 售价 - 折后价*/
    get yh(){
        let val = 0;
        let sellingPrice = this.form.sellingPrice?this.form.sellingPrice:0;
        let discountPrice = this.discountPrice?this.discountPrice:0;
        val = calculate.subtraction(sellingPrice,discountPrice);
        return val;
    }
    /**折后价:售价 * 商品折扣 * 会员折扣 */
    get discountPrice(){
        let val = 0;
        let sellingPrice = this.form.sellingPrice?this.form.sellingPrice:0;
        let discountPrice = this.form.discountPrice?this.form.discountPrice:0;
        let gradeDiscount = this.form.isMemberDiscount?this.memberInfo.id?this.memberInfo.gradeDiscount==0&&!this.memberInfo.gradeId?1:calculate.division(this.memberInfo.gradeDiscount,10):1:1;
        if(discountPrice){
            val = calculate.multiplication(discountPrice,gradeDiscount);
        }else{
            val = calculate.multiplication(sellingPrice,gradeDiscount);
        }
        return val;
    }
    /**小计 */
    get subTotal(){
        let val = 0;
        if(this.stock){
            val = calculate.multiplication(this.discountPrice,Number(this.stock));
        }
        return val;
    }

    /**是否是赠品 */
    isGift = false;

    isEdit=false;

    /**判断是否支持负库存以及当前库存是否大于0 */
    get chargeStock(){
        let val = false;
        if(this.isZeroStock){
            val = false;
        }else{
            if(this.nowStock<=0){
                val = true;
            }
        }
        return val;
    }
    userInfo:any={};

    async mounted() {
        
    }
    async created() {
        this.userInfo = JSON.parse(localStorage.getItem('padUserinfo'));
    }

    async showFun(id){
        this.isEdit = false;
        this.noCancel = false;
        this.id = id;
        this.stock = 0;
        this.originStock=0;
        this.nowStock=0;
        this.specsSelectedList=[];
        this.selectedList=[];
        this.oldGwList = this.gwList? JSON.parse(this.gwList):[]; 
        this.isGift = false;
        await this.getDetail();
        this.show = true;
    }
    async showDetailFun(id){
        this.isEdit = true;
        this.noCancel = false;
        this.id = id;
        this.stock = 0;
        this.originStock=0;
        this.nowStock=0;
        this.specsSelectedList=[];
        this.selectedList=[];
        this.oldGwList = this.gwList? JSON.parse(this.gwList):[]; 
        await this.getDetail2();
        this.show = true;
    }
    /**获取详情 */
    async getDetail(){
        let res = await TbGoods.GetTbGoodsById({id:this.id});
        this.form = res;
        /**无规格 */
        if(!res.goodsSpecsIds){
            let index = this.oldGwList.findIndex(j=>j.goodsItemId==res.getGoodsItemsList[0].id);
            let stock = res.getGoodsItemsList[0].stock;
            let selectedNumTotalArr = this.oldGwList.filter(v=>v.goodsItemId==res.getGoodsItemsList[0].id).map(v=>v.num);
            let selectedNumTotal = 0
            if(selectedNumTotalArr.length>0){
                selectedNumTotal = selectedNumTotalArr.reduce((a,b)=>calculate.addition(a,b));
            }
            
            if(index>-1){
                let form = this.oldGwList[index];
                this.originStock = calculate.subtraction(stock,selectedNumTotal);
                this.stock = this.isZeroStock?1:calculate.subtraction(calculate.subtraction(stock,selectedNumTotal),1)>=0?1:0;
                this.nowStock = this.isZeroStock?calculate.subtraction(calculate.subtraction(stock,selectedNumTotal),1):calculate.subtraction(calculate.subtraction(stock,selectedNumTotal),1)>=0?calculate.subtraction(calculate.subtraction(stock,selectedNumTotal),1):calculate.subtraction(stock,selectedNumTotal);
            }else{
                this.originStock = stock;
                this.stock = this.isZeroStock? 1 : calculate.subtraction(stock,1)>=0?1:0;
                this.nowStock = this.isZeroStock? calculate.subtraction(stock,1):calculate.subtraction(stock,1)>=0?calculate.subtraction(stock,1):stock;
            }
        }else{
            await this.getInitGGListU(res.goodsSpecsIds);
            let goodsSpecsList= res.goodsSpecsIds.split(',');
            /**两种规格，且都只有一个规格值 */
            if((goodsSpecsList.length==2||goodsSpecsList.length==1)&&res.getGoodsItemsList.length==1){
                let stock = res.getGoodsItemsList[0].stock;
                this.noCancel = true;
                this.selectedSpecName = res.getGoodsItemsList[0].goodsSpecsName;
                this.specsSelectedList.forEach(v=>{
                    this.selectedList.push(v);
                })
                let index = this.oldGwList.findIndex(j=>j.goodsItemId==res.getGoodsItemsList[0].id);
                let selectedNumTotalArr = this.oldGwList.filter(v=>v.goodsItemId==res.getGoodsItemsList[0].id).map(v=>v.num);
                let selectedNumTotal = 0
                if(selectedNumTotalArr.length>0){
                    selectedNumTotal = selectedNumTotalArr.reduce((a,b)=>calculate.addition(a,b));
                }
                if(index>-1){
                    let form = this.oldGwList[index];
                    this.originStock = calculate.subtraction(stock,selectedNumTotal);
                    this.stock = this.isZeroStock?1:calculate.subtraction(calculate.subtraction(stock,selectedNumTotal),1)>=0?1:0;
                    this.nowStock = this.isZeroStock?calculate.subtraction(calculate.subtraction(stock,selectedNumTotal),1):calculate.subtraction(calculate.subtraction(stock,selectedNumTotal),1)>=0?calculate.subtraction(calculate.subtraction(stock,selectedNumTotal),1):calculate.subtraction(stock,selectedNumTotal);
                }else{
                    this.originStock = stock;
                    this.stock = this.isZeroStock?1:calculate.subtraction(stock,1)>=0 ?1:0
                    this.nowStock = this.isZeroStock?calculate.subtraction(stock,1):calculate.subtraction(stock,1)>=0?calculate.subtraction(stock,1):stock;
                }
            }
            // console.log('specsSelectedList',this.specsSelectedList);
            
            
        }
    }
    async getDetail2(){
        // let res = await TbGoods.GetTbGoodsById({id:this.id});
        // this.form = res;
        // /**无规格 */
        // if(!res.goodsSpecsIds){
        //     let index = this.oldGwList.findIndex(j=>j.goodsItemId==res.getGoodsItemsList[0].id);
        //     let form = this.oldGwList[index];
        //     this.stock = form.num;
        //     this.isGift = form.isGift;
        //     this.originStock = calculate.subtraction(res.totalStock,form.num);
        //     this.nowStock = calculate.subtraction(res.totalStock,form.num);
           
        // }else{
        //     await this.getInitGGListU(res.goodsSpecsIds);
        //     let goodsSpecsList= res.goodsSpecsIds.split(',');
        //     /**两种规格/一种规格，且都只有一个规格值 */
        //     if((goodsSpecsList.length==2||goodsSpecsList.length==1)&&res.getGoodsItemsList.length==1){
        //         let stock = res.getGoodsItemsList[0].stock;
        //         this.noCancel = true;
        //         this.selectedSpecName = res.getGoodsItemsList[0].goodsSpecsName;
        //         this.specsSelectedList.forEach(v=>{
        //             this.selectedList.push(v);
        //         })
        //         let index = this.oldGwList.findIndex(j=>j.goodsItemId==res.getGoodsItemsList[0].id);
        //         let form = this.oldGwList[index];
        //         this.isGift = form.isGift;
        //         this.stock = form.num;
        //         this.originStock = stock;
        //         this.nowStock = calculate.subtraction(stock,form.num);
                
        //     }
        //     // console.log('specsSelectedList',this.specsSelectedList);
            
            
        // }
    }

    async getInitGGListU(ids){
        // console.log('ids',ids);
        let res = await TbGoodsSpecs.GetTbGoodsSpecsList();
        let arr= ids.split(',');
        let selectArr=res.filter(v=>arr.findIndex(j=>j==v.id)>-1);
        selectArr = selectArr.map(v=>{
            return {
                ...v,
                index:arr.findIndex(j=>j==v.id)
            }
        })
        /**按照specid排序，不然对不上 */
        selectArr.sort((a,b)=>a.index-b.index);
        this.specsSelectedList = selectArr.map((v,index)=>{
            return{
                id:v.id,
                name:v.name,
                childList: index==0? v.specsItemsJson.filter(j=>this.form.itemSpecsIds1.split(',').findIndex(fi=>fi==j.id)>-1).map(jj=>{
                    return {
                        ...jj,
                        parentId:v.id
                    }
                }):
                v.specsItemsJson.filter(j=>this.form.itemSpecsIds2.split(',').findIndex(fi=>fi==j.id)>-1).map(jj=>{
                    return {
                        ...jj,
                        parentId:v.id
                    }
                })
                

            }
        })
        // this.specsSelectedList = this.specsSelectedList.reverse();
        
        
    }

    closeFun(){
        this.show = false;
    }
    ImgUrl:string = ''
    /**预览图片 */
    viewImg(url){
        this.ImgUrl = url
        this.$nextTick(()=>{
            this.$refs.imageDialog.opens()
        })
    }
    finishStep(val){
        this.stock = Number(val);
        this.$nextTick(()=>{
            if(!this.isZeroStock&&this.stock>this.originStock){
                this.stock = this.originStock
            }
            this.calcStock();
        })
    }
    /**计算最新库存 */
    calcStock(){
        this.nowStock = calculate.subtraction(this.originStock,this.stock); 
    }
    /**加入购物车 */
    addProduct(isGift=false){
        if(this.form.goodsSpecsIds&&this.selectedList.length==0){
            this.$emit('tipFun')
            return;
        }
        if(!this.stock||Number(this.stock==0)){
            this.$emit('tipFun')
            return;
        }
        
        let obj = Object.assign({},this.form,{addGoodsItemsList:this.formateAddGoodsItemsList()},{num:this.stock,isGift:isGift,isEdit:this.isEdit});
        this.$emit("addProduct",obj);
        this.closeFun();
    }
    formateAddGoodsItemsList(){
        let arr = [];

        if(!this.form.goodsSpecsIds){
            arr = this.form.getGoodsItemsList;
        }else{
            arr = this.form.getGoodsItemsList.filter(v=>v.goodsSpecsName==this.selectedSpecName)
        }
        return arr;
    }
    /**选择规格 */
    async chooseSpec(item,v){
        if(this.getGGActive(item,v)=='isDisable') return;
        if(this.noCancel) return;
        let index = this.selectedList.findIndex(j=>j.id==item.id);
        if(index>-1){
            let chidIndex = this.selectedList[index].childList.findIndex(j=>j.id==v.id);
            if(chidIndex>-1){
                this.selectedList.splice(index,1);
                
            }else{
                this.selectedList[index].childList.splice(chidIndex,1);
                this.selectedList[index].childList.push({
                    id:v.id,
                    name:v.name,
                    parentId:item.id
                })
            }
        }else{
            this.selectedList.push({
                id:item.id,
                name:item.name,
                childList:[{
                    id:v.id,
                    name:v.name,
                    parentId:item.id
                }]
            })
        }
        await this.getSpecStock();
        
    }
    /**查询规格状态 */
    getGGActive(item,v){
        let str = "";
        if(this.selectedList.length>0&&this.specsSelectedList.length==2){
            
            let otherArr = this.selectedList.filter(j=>j.id!=item.id); 
            if(otherArr.length>0){
               
                let otherName = otherArr[0].childList[0].name;
                let otherIndex = this.specsSelectedList.findIndex(v=>v.id== otherArr[0].id); 
                let pName = otherIndex==0?otherName+'/'+v.name:v.name+'/'+otherName;
                if(this.form.getGoodsItemsList.findIndex(j=>j.goodsSpecsName==pName)==-1){
                        str = 'isDisable'
                        return str;
                    }
            }

        }
        let index = this.selectedList.findIndex(j=>j.id==item.id)
        if(index>-1){
            if(this.selectedList[index].childList.some(j=>j.id==v.id)){
                str = "isActive";
                return str;
            }
        }
        
        return str;
    }
    /**查询规格库存 */
    async getSpecStock(){
        this.selectedSpecName = "";
        this.stock = 0;
        this.originStock=0;
        this.nowStock=0;

        let specName = "";
        if(this.selectedList.length>0){
            if(this.selectedList.length==1){
                if(this.specsSelectedList.length==1){
                    specName=this.selectedList[0].childList[0].name+'/-';
                    if(this.form.getGoodsItemsList.some(v=>v.goodsSpecsName==specName)){
                        let index = this.oldGwList.findIndex(j=>j.goodsItemId==this.form.getGoodsItemsList.find(v=>v.goodsSpecsName==specName).id);
                        // console.log('index',index,this.oldGwList);
                        let stock = this.form.getGoodsItemsList.find(v=>v.goodsSpecsName==specName).stock;

                        let selectedNumTotalArr = this.oldGwList.filter(v=>v.goodsItemId==this.form.getGoodsItemsList.find(v=>v.goodsSpecsName==specName).id).map(v=>v.num);
                        let selectedNumTotal = 0
                        if(selectedNumTotalArr.length>0){
                            selectedNumTotal = selectedNumTotalArr.reduce((a,b)=>calculate.addition(a,b));
                        }

                        if(index>-1){
                            let form = this.oldGwList[index];
                            this.originStock = calculate.subtraction(stock,selectedNumTotal);
                            this.stock = this.isZeroStock? 1 :calculate.subtraction(calculate.subtraction(stock,selectedNumTotal),1)>=0?1:0;
                            this.nowStock = this.isZeroStock?calculate.subtraction(calculate.subtraction(stock,selectedNumTotal),1):calculate.subtraction(calculate.subtraction(stock,selectedNumTotal),1)>=0?calculate.subtraction(calculate.subtraction(stock,selectedNumTotal),1):calculate.subtraction(stock,selectedNumTotal);
                            this.selectedSpecName= specName;
                        }else{
                            this.originStock= stock;
                            this.stock = this.isZeroStock? 1 :calculate.subtraction(stock,1)>=0?1:0;
                            this.nowStock= this.isZeroStock?calculate.subtraction(stock,1):calculate.subtraction(stock,1)>=0?calculate.subtraction(stock,1):stock;
                            this.selectedSpecName= specName;
                        }
                    }
                }
                
            }else{
                let arr = this.form.goodsSpecsIds?this.form.goodsSpecsIds.split(","):[];
                this.selectedList = this.selectedList.map(v=>{
                    return{
                        ...v,
                        index:arr.findIndex(j=>j==v.id)
                    }
                })
                this.selectedList.sort((a,b)=>a.index-b.index);
                specName=this.selectedList[0].childList[0].name+'/'+this.selectedList[1].childList[0].name;
                if(this.form.getGoodsItemsList.some(v=>v.goodsSpecsName==specName)){
                    let index = this.oldGwList.findIndex(j=>j.goodsItemId==this.form.getGoodsItemsList.find(v=>v.goodsSpecsName==specName).id);

                    let selectedNumTotalArr = this.oldGwList.filter(v=>v.goodsItemId==this.form.getGoodsItemsList.find(v=>v.goodsSpecsName==specName).id).map(v=>v.num);
                    let selectedNumTotal = 0
                    if(selectedNumTotalArr.length>0){
                        selectedNumTotal = selectedNumTotalArr.reduce((a,b)=>calculate.addition(a,b));
                    }
                    // console.log('index',index,this.oldGwList,specName);
                    let stock = this.form.getGoodsItemsList.find(v=>v.goodsSpecsName==specName).stock;;
                    if(index>-1){
                        let form = this.oldGwList[index];
                        this.originStock = calculate.subtraction(stock,selectedNumTotal);
                        this.stock = this.isZeroStock? 1 :calculate.subtraction(calculate.subtraction(stock,selectedNumTotal),1)>=0?1:0;
                        this.nowStock = this.isZeroStock?calculate.subtraction(calculate.subtraction(stock,selectedNumTotal),1):calculate.subtraction(calculate.subtraction(stock,selectedNumTotal),1)>=0?calculate.subtraction(calculate.subtraction(stock,selectedNumTotal),1):calculate.subtraction(stock,selectedNumTotal);
                        this.selectedSpecName= specName;
                    }else{
                        this.originStock= stock;
                        this.stock = this.isZeroStock? 1 :calculate.subtraction(stock,1)>=0?1:0;
                        this.nowStock= this.isZeroStock?calculate.subtraction(stock,1):calculate.subtraction(stock,1)>=0?calculate.subtraction(stock,1):stock;
                        this.selectedSpecName= specName;
                    }
                }
                
            }
        }else{
            this.selectedSpecName = "";
            this.stock = 0;
            this.originStock=0;
            this.nowStock=0;
        }  
    }
    /**判断权限 */
    hasAuth(auth) {
        let val = false;
        let btnPermissionsStr = this.userInfo['authorityJson'].split(',');
        if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
        val = false;
        }
        if (btnPermissionsStr.some(v=>v==auth)) {
        val = true;
        }
        return val;
    }
   /**判断库存是否显示 */
   chargeStockShow(){
        let val = false;
        if(!this.form.goodsSpecsIds){
            val = true;
        }else{
            let goodsSpecsIdsArr =this.form.goodsSpecsIds? this.form.goodsSpecsIds.split(","):[];
            if(goodsSpecsIdsArr.length==this.selectedList.length){
                val = true;
            }
        }

        return val;
   }
   /**判断计数器禁用 */
   chargeCounter(){
        let val = false;
        let goodsSpecsIdsArr = this.form.goodsSpecsIds?this.form.goodsSpecsIds.split(","):[];
        if(this.form.goodsSpecsIds&&goodsSpecsIdsArr.length!=this.selectedList.length||!this.isZeroStock&&this.nowStock<0){
            val = true;
        }
        return val;
   }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/cashier/components/productDetail.vue